import { Context } from "@nuxt/types";

export const getAndCheckUrl = (query: any, redirectWhitelist: string[]) => {
  const { url } = query;
  let redirectUrl: string = "";
  if (Array.isArray(url)) {
    // query为url=aaa&url=bbb时，url是一个数组，这种情况取最后一个url的值
    redirectUrl = url[url.length - 1];
  } else {
    redirectUrl = url && String(url);
  }
  const { origin: urlOrigin, query: urlQuery } = parseUrl(
    decodeURIComponent(redirectUrl)
  );

  if (!redirectUrl || !checkURL(redirectWhitelist, urlOrigin)) return false;

  // 拼接最后的跳转链接
  const otherQuery = { ...query, ...urlQuery };
  delete otherQuery.url;
  return joinUrl(urlOrigin, otherQuery);
};

function checkURL(redirectWhitelist: string[], sURL: string) {
  const link = document.createElement("a");
  link.href = sURL;
  return (
    /^https?:$/.test(link.protocol) &&
    redirectWhitelist.some(host => {
      const checkReg = new RegExp(`^([\\w\\-]+\\.)*${host}$`, "i");
      return checkReg.test(link.host);
    })
  );
}

export function parseUrl(url: string) {
  // 去除 hash
  const transUrl = url.split('#')[0]
  const [origin, search] = transUrl.split("?");
  
  const query = search
    ? search.split("&").reduce((total: Record<string, string>, item) => {
        const [key, value] = item.split("=");
        total[key] = value;
        return total;
      }, {})
    : {};
  return {
    origin,
    query
  };
}

export const joinUrl = (url: string, query: any) => {
  const queryArr: string[] = [];
  Object.keys(query).forEach(key => {
    queryArr.push(key + "=" + query[key]);
  });
  return queryArr.length ? url.split("?")[0] + "?" + queryArr.join("&") : url;
};

export const extendUrl = (
  url: string = "",
  query: Record<string, string> = {}
): string => {
  try {
    const obj = new URL(url);
    Object.entries(query).forEach(([k, v]) => obj.searchParams.set(k, v));
    return obj.href;
  } catch (_error) {
    return url;
  }
};

/**
 * 通用跳转函数，供nuxt plugin使用注入
 * @param context nuxt 上下文对象
 * @param url 要跳转的URL
 * @param extraSearchParams 要额外添加的参数
 * @param avoidParams 函数内部会带上当前页面和父页面query，此参数用来排除一些不需要的参数，主要为了对齐支持之前代码的lang参数不携带的场景
 */
export function handleRedirection(
  context: Context,
  url: string,
  extraSearchParams: Record<string, string> = {},
  avoidParams: string[] = []
) {
  const routeQuery = context.route.query;
  const parentPageQuery = context.store.state.onlyForm?.topUrlParams;
  const resultAvoidParams = [
    // keep_global_loading 为自定义 query，也去除一下
    'keep_global_loading',
    ...avoidParams
  ]

  // 携带上本页面和父页面的search params
  let query = { ...routeQuery, ...parentPageQuery };
  // 剔除掉不需要的参数
  resultAvoidParams.forEach(key => {
    delete query[key];
  });
  // 带上参数传入的额外search params
  query = { ...query, ...extraSearchParams };

  const toHref = extendUrl(url, query);

  // 延迟跳转，防止外部有上报未完成
  setTimeout(() => {
    // 被iframe嵌入则通知父页面跳转
    if (context?.$displayFormInIframe) {
      context?.$handshake?.redirect({
        url: toHref,
        target: "_self"
      });
    } else {
        window.location.href = toHref;
    }
  }, 300);
}


/**
 * 小弹窗打开，返回打开的window 对象
 * flag设为固定字符串 可以固定只打开一个tab
 */
 export const openInner = (url: string, options?: { width?: number; height?: number; flag?: string }) => {
  const modalWidth = options?.width || 1000; // 弹出窗口的宽度;
  const modalHeight = options?.height || 1000; // 弹出窗口的高度;
  const modalTop = (window.screen.availHeight - 30 - modalHeight) / 2; // 获得窗口的垂直位置;
  const modalLeft = (window.screen.availWidth - 10 - modalWidth) / 2; // 获得窗口的水平位置;

  return window.open(
    url,
    options?.flag || '_blank',
    `height=${modalHeight},width=${modalWidth},top=${modalTop},left=${modalLeft}',toolbar=no,menubar=no,alwaysRaised=yes'`
  );
};
